<template>
    <div>
        {{ $t('notification.userNameChanged', { 
            actor: $_.get(activity, 'actorUser.name'), 
            userName: $_.get(activity, 'payload.userName'),
            oldName: $_.get(activity, 'payload.oldName'),
            newName: $_.get(activity, 'payload.newName')
        }) }}
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "UserNameChanged",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

